import { writable, readable } from "svelte/store";
import { ListStore } from "../common/list-store/entity";
import {
  defaultSubscriptionTerm,
  subscriptionTerms,
} from "./userConstants";

const userTemplate = readable({
  id: "",
  initial: "",
  middleName: "",
  lastName: "",
  email: "",
  phoneNumber: "",
  birthDate: "",
  ehLevel: "EH3",
  subscriptionTerm: defaultSubscriptionTerm,
  secondFactor: "Geen",
  existingAccount: false,
  idType: "Identiteitskaart",
  documentNumber: "",
  documentExpiryDate: "",
  idCountry: "Nederland",
  allOrganizations: false,
  organizations: [],
  admin: false,
  employed: false,
});

export let currentUser = writable({ ...userTemplate });

const knownSubscriptionTerms = subscriptionTerms.map((term) => term.value);

let storedUsers = !sessionStorage.getItem("userStore")
  ? []
  : JSON.parse(sessionStorage.getItem("userStore")).map((user) => ({
      ...user,
      subscriptionTerm: knownSubscriptionTerms.includes(user.subscriptionTerm)
        ? user.subscriptionTerm
        : defaultSubscriptionTerm,
    }));

export const userStore = writable(storedUsers);

userStore.subscribe((value) => {
  sessionStorage.setItem("userStore", JSON.stringify(value));
});

export let userList = new ListStore(userTemplate, userStore, currentUser);
